import { UI_LANGUAGES } from "../lib/i18n/languages.js";
import { setLanguage, useLanguage, useT } from "../lib/i18n/store.js";

/**
 * Compact interface-language picker for the topbar. A native <select> so it is
 * keyboard- and screen-reader-friendly for free and needs no open/close state.
 */
export function LanguageSelect() {
  const lang = useLanguage();
  const t = useT();
  return (
    <label className="nav-lang" title={t("nav.interfaceLanguage")}>
      <span className="sr-only">{t("nav.interfaceLanguage")}</span>
      <select
        className="nav-lang-select"
        value={lang}
        onChange={(event) => setLanguage(event.target.value)}
        aria-label={t("nav.interfaceLanguage")}
      >
        {UI_LANGUAGES.map((language) => (
          <option key={language.code} value={language.code}>
            {language.label}
          </option>
        ))}
      </select>
    </label>
  );
}
